module.exports = __webpack_public_path__ + "media/images/tree-plaque-497fe22e8611ba56d24235343e314232.png";